import styled, { css } from "styled-components";
import Divider from "@mui/material/Divider";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
const FlexDiv = styled.div `
    display: flex;
`;
export const FlexRowDiv = styled(FlexDiv) `
    flex-direction: row;
    gap: ${(props) => { var _a; return (_a = props.gap) !== null && _a !== void 0 ? _a : 0; }}px;
    align-items: ${(props) => { var _a; return (_a = props.alignItems) !== null && _a !== void 0 ? _a : "flex-start"; }};
`;
export const FlexRowDivCentered = styled(FlexRowDiv) `
    align-items: center;
    justify-content: center;
`;
export const FlexColumnDiv = styled(FlexDiv) `
    flex-direction: column;
    gap: ${(props) => { var _a; return (_a = props.gap) !== null && _a !== void 0 ? _a : 0; }}px;
`;
export const FlexColumn = styled(FlexColumnDiv) `
    align-self: stretch;
    align-items: ${(props) => (props.alignItems ? props.alignItems : "flex-start")};
    gap: ${(props) => { var _a; return (_a = props.gap) !== null && _a !== void 0 ? _a : 0; }}px;
    opacity: ${(props) => { var _a; return (_a = props.opacity) !== null && _a !== void 0 ? _a : 1; }};

    ${(props) => props.grow &&
    css `
            flex: 1 0 0;
        `}
`;
export const FlexRow = styled(FlexRowDiv) `
    align-self: stretch;
    align-items: ${(props) => (props.alignItems ? props.alignItems : "flex-start")};
    gap: ${(props) => { var _a; return (_a = props.gap) !== null && _a !== void 0 ? _a : 0; }}px;
    opacity: ${(props) => { var _a; return (_a = props.opacity) !== null && _a !== void 0 ? _a : 1; }};

    ${(props) => props.grow &&
    css `
            flex: 1 0 0;
        `}
`;
export const InlineFlexRow = styled(FlexRow) `
    display: inline-flex;
`;
export const FlexRowSpaceBetween = styled(FlexRow) `
    justify-content: space-between;
`;
export const HorizontalDivider = styled(Divider) `
    align-self: stretch;

    ${(props) => props.disabled &&
    css `
            border-color: ${colors.black_30};
        `}

    ${(props) => props.center &&
    css `
            justify-content: center;
            align-self: center;
        `}

    ${(props) => props.flex &&
    css `
            flex: 1;
        `}
`;
export const SectionTitleSeparator = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
`;
export const SectionTitleSeparatorText = styled.span `
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.black_lighter};
    text-transform: uppercase;
    letter-spacing: 0.24px;
    white-space: nowrap;
`;
export const VerticalDivider = styled(Divider).attrs({ orientation: "vertical" }) `
    align-self: stretch;
    height: auto;
`;
export const PreWrap = styled.div `
    white-space: pre-wrap;
`;
export const VisuallyHiddenInput = styled.input `
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
`;
export const MailtoLinkInherit = styled.a `
    color: inherit;
    text-decoration: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    font-size: inherit;
    font-family: inherit;
    font-style: inherit;
`;
export const CodeBlock = styled.div `
    white-space: pre;
    font-family: monospace;
    font-size: ${fontSizes.SMALL};
    padding: 16px;
    background-color: ${colors.black_12};
    align-self: stretch;
`;
